// src/App.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Navbar from './components/common/Navbar';
import Footer from './components/common/Footer';
import { 
  Home, 
  TiffinService,
  CartService,
  MonthlyBook,
  DateSelect, 
  TimeSelect, 
  Payment, 
  Checkout,
  OrderSuccess, 
  OrderFailed,
  Profile,
  EditProfile,
  SavedAddresses,
  PaymentMethods,
  MyOrders,
  ProductDetails,
  Login,
  PrivacyPolicy,
  DeleteAccountInfo,
  DeleteAccount,
  ProfileForm
} from './components/pages';

// ✅ FIXED: Import About from the correct path
import About from './components/pages/About'; // <-- Fixed path

// Import CheckoutService and ViewCart directly
import CheckoutService from './components/pages/CheckoutService';
import ViewCart from './components/pages/ViewCart';

import './App.css';

function App() {
  const theme = useSelector((state) => state.theme.mode);
  
  return (
    <div className={`min-h-screen flex flex-col transition-colors duration-300 ${theme}`}>
      <Navbar />
      <main className="flex-1 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 w-full">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/tiffin-service" element={<TiffinService />} />
          <Route path="/tiffin-service/date-wise" element={<DateSelect />} />
          <Route path="/tiffin-service/monthly-book" element={<MonthlyBook />} />
          <Route path="/cart-service" element={<CartService />} />
          <Route path="/view-cart" element={<ViewCart />} />
          <Route path="/checkout-service" element={<CheckoutService />} />
          <Route path="/product/:id" element={<ProductDetails />} />
         
          <Route path="/date-select" element={<DateSelect />} />
          <Route path="/time-select" element={<TimeSelect />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/payment" element={<Payment />} />
          <Route path="/order-success" element={<OrderSuccess />} />
          <Route path="/order-failed" element={<OrderFailed />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/edit-profile" element={<EditProfile />} />
          <Route path="/saved-addresses" element={<SavedAddresses />} />
          <Route path="/payment-methods" element={<PaymentMethods />} />
          <Route path="/my-orders" element={<MyOrders />} />
          <Route path="/orders" element={<MyOrders />} />
          <Route path="/login" element={<Login />} />
          <Route path="/privacy" element={<PrivacyPolicy />} /> 
          <Route path="/delete-account" element={<DeleteAccount />} />
          <Route path="/profile-form" element={<ProfileForm />} />
          <Route path="/delete-account-info" element={<DeleteAccountInfo />} />
          <Route path="/about" element={<About />} /> {/* ✅ About route */}
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;